/**
 * Звонок в ленте.
 *
 * Telegram рисует звонок пузырём с трубкой: заголовок — исход («Исходящий
 * звонок», «Пропущенный видеозвонок»), под ним длительность. Пропущенный и
 * отменённый — красным: это единственное, на что менеджеру нужно
 * отреагировать, и оно должно бросаться в глаза в длинной переписке.
 */

import type { TelegramCallDto } from '@tw/shared-types';
import { cn } from '@/lib/utils';
import { callLabel, formatCallDuration } from '@/lib/message-summary.ts';
import { PhoneIncomingIcon, PhoneMissedIcon, PhoneOutgoingIcon, VideoIcon } from './icons.tsx';

interface CallCardProps {
  call: TelegramCallDto;
  outgoing: boolean;
}

export function CallCard({ call, outgoing }: CallCardProps) {
  const failed = call.outcome === 'missed' || call.outcome === 'cancelled' || call.outcome === 'declined';
  const Icon = failed ? PhoneMissedIcon : call.video ? VideoIcon : outgoing ? PhoneOutgoingIcon : PhoneIncomingIcon;

  const detail = call.duration > 0 ? formatCallDuration(call.duration) : null;

  return (
    <div className="mb-1 flex min-w-[180px] items-center gap-2.5 pr-[54px]">
      <span
        className={cn(
          'grid size-9 flex-none place-items-center rounded-full',
          failed ? 'bg-red-500/15 text-red-500' : outgoing ? 'bg-white/20' : 'bg-white/10',
        )}
      >
        <Icon className="size-[18px]" />
      </span>
      <span className="flex min-w-0 flex-col leading-tight">
        <span className={cn('text-sm font-medium', failed && 'text-red-500')}>
          {callLabel(call, outgoing)}
        </span>
        {detail && <span className="text-[11px] opacity-70">{detail}</span>}
      </span>
    </div>
  );
}
